import { render, staticRenderFns } from "./TagsManager.vue?vue&type=template&id=6fec75b0"
import script from "./TagsManager.vue?vue&type=script&lang=ts"
export * from "./TagsManager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports